var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCosmetics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#707070"
    },
    d: "M229.574,453.023l-97.217-0.747c-10.937-0.085-19.735-9.018-19.65-19.955l0.593-77.007 c0.083-10.937,9.018-19.735,19.955-19.65l97.217,0.749c10.937,0.083,19.735,9.018,19.65,19.955l-0.593,77.007 C249.446,444.309,240.51,453.107,229.574,453.023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8546"
    },
    d: "M108.743,0C82.483,0,61.829,22.433,63.99,48.603l16.917,204.739c0,0.004,0.001,0.009,0.001,0.015 l10.625,98.439c0.54,21.466,18.087,38.845,39.716,39.011l93.102,0.716c21.631,0.166,39.442-16.938,40.312-38.396l31.197-303.633 C298.58,23.018,277.805,0,251.19,0H108.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E03905"
    },
    d: "M251.19,0h-72.256v391.173l45.418,0.35c21.631,0.166,39.442-16.938,40.312-38.396l31.197-303.633 C298.58,23.018,277.805,0,251.19,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F4F4"
    },
    d: "M370.601,314.487H256.143c-10.937,0-19.803-8.867-19.803-19.803v-90.662 c0-10.937,8.867-19.803,19.803-19.803h114.458c10.937,0,19.803,8.867,19.803,19.803v90.662 C390.405,305.62,381.538,314.487,370.601,314.487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCF7F5"
    },
    d: "M375.841,511.997l-126.752-0.976c-39.18-0.301-70.81-32.422-70.509-71.602l0.721-93.632 c0.301-39.179,32.422-70.809,71.601-70.508l126.752,0.974c39.18,0.302,70.81,32.422,70.509,71.601l-0.72,93.632 C447.141,480.668,415.02,512.298,375.841,511.997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8546"
    },
    d: "M313.371,453.023c-33.233,0-60.268-27.037-60.268-60.27s27.037-60.27,60.268-60.27 c33.233,0,60.27,27.037,60.27,60.27S346.603,453.023,313.371,453.023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M370.601,184.216h-57.27v130.269h57.27c10.937,0,19.803-8.867,19.803-19.803v-90.662 C390.405,193.083,381.538,184.216,370.601,184.216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#74D6D0"
    },
    d: "M377.654,276.256l-64.324-0.495v235.755l62.51,0.481c39.18,0.301,71.3-31.329,71.602-70.509 l0.72-93.632C448.464,308.678,416.834,276.558,377.654,276.256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E03905"
    },
    d: "M313.371,332.484c-0.013,0-0.026,0.001-0.041,0.001v120.538c0.013,0,0.026,0.001,0.041,0.001 c33.233,0,60.27-27.037,60.27-60.27C373.64,359.521,346.603,332.484,313.371,332.484z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCosmetics);
export default __webpack_public_path__ + "static/media/cosmetics.2012f8512efe65e60db71f6961b25131.svg";
export { ForwardRef as ReactComponent };